export default [
    {
        package: "Public Pkg #1",
        name: "Start-up Website",
        id: 0,
        price: 200.00,
        info01: "* Simple website up to 5 pages - Including Home, About, & Contact.",
        info02: "* Once approved will provide you with the upload files",
        finished: "Typical turn-around is 5-10 business days",
    },
    {
        package: "Public Pkg #2",
        name: "Start-up with hosting",
        id: 1,
        price: "270.00",
        info01: "* Simple website up to 5 pages - Including Home, About, & Contact.",
        info02: "* Create Domain Name and Hosting accounts in your name.",
        info03: "* One approved will upload files to the hosting account.",
        info04: "* Once uploaded will turn over all hosting and domain account information (future billing will be your responsibility unless Add-on is purchased).",
        finished: "Typical turn-around is 7-10 business days",
    },
];